import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../../../share/src/util/api/polling';
import { createColumns, createDisplayData } from './table';

/** 
 * データ読み出し処理
 * @param {object} self this インスタンス
 */
export async function read(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'read',
        is_special: true,
        control_history_type: self.controlHistoryType,
        version: self.controlHistoryType === 'wall_avoid' ? null : self.additionalInfo.version
      },
      // エラー発生のコールバック
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
    );

    if (response) {
      // セッション遷移の状態を更新 取得できない場合はtrueをセットしてexit APIを呼び出す
      self.isSession = response.data?.user_data?.is_session ?? true;
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // CCから取得データを参照する為、Sort_KeyにあたるリクエストIDを次のAPIに渡す
          await dataFormat(self, response.data.user_data.request_id);
          break;
        case REQUEST_STATUS_FAILED:
        default:
          self.showUnexpectedError();
          break;
      }
    } else {
      // セッション遷移の状態をtrueに更新し、exit APIが実行されるようにしておく
      self.isSession = true;
      self.showUnexpectedError();
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * データ整形API実行
 * @param {object} self this インスタンス
 * @param {String} request_id リクエストID
 */
async function dataFormat(self, request_id) {
  // バックエンドAPI POST,GET
  const token = session.getToken();
  const response = await individualWorkSupportUtil.pollingWspApi(
    self,
    self.netAppId,
    self.systemId,
    self.workSupportId,
    {
      id_token: token.id_token,
      type: 'format',
      is_special: true,
      project_id: self.vehicleInfo.vehicle.project.id,
      request_id: request_id,
      control_history_type: self.controlHistoryType,
      version: self.controlHistoryType === 'wall_avoid' ? null : self.additionalInfo.version
    },
    // エラー発生のコールバック
    (errorType) => { errorType; self.showUnexpectedError(); },
    // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { self.validateErrorResult(result); },
    // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { self.validateErrorResult(result); },
  );

  if (response) {
    switch (response.data.status) {
      case REQUEST_STATUS_COMPLETED:
        self.preFdData = response.data.user_data.fd_data_list;
        self.preDetailFdData = response.data.user_data.detail_fd_list;
        // プロジェクトデータ保存画面表示用データ名初期値の設定
        self.preDataName = response.data.user_data.data_name;
        self.dataNameSuffix = parseInt(self.preDataName.substring(4));
        createColumns(self);
        createDisplayData(self);
        break;
      case REQUEST_STATUS_FAILED:
      default:
        self.showUnexpectedError();
        break;
    }
  } else {
    self.showUnexpectedError();
  }
}
